import React from 'react';
import './Navigation.css';

function Navigation({ onNavigate }) {
  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => onNavigate('home')}>
          <h1>📱 React Native Lite UI</h1>
        </div>
        <ul className="nav-links">
          <li><a onClick={() => onNavigate('home')}>Home</a></li>
          <li><a onClick={() => onNavigate('getting-started')}>Getting Started</a></li>
          <li><a href="https://github.com/chandannath98/react-native-lite-ui" target="_blank" rel="noreferrer">GitHub</a></li>
          <li><a href="https://npmjs.com/package/react-native-lite-ui" target="_blank" rel="noreferrer">NPM</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
